import React from "react";
import { useLocation } from "react-router-dom";
import useSiteConfig from "@/hooks/useSiteConfig";
import { useAuth } from "@/context/AuthContext";
import UnderConstruction from "@/pages/public/UnderConstruction";

/**
 * Wraps PublicLayout. When maintenance_mode_enabled is true AND the visitor is
 * NOT an authenticated admin, the cover is shown instead of `children`.
 *
 * Exceptions (always pass through, even during maintenance):
 *   - /checkout/success, /checkout/cancel  (in-flight payment confirmations)
 *
 * Bypass when:
 *   - the AuthContext reports an authenticated user (admin browsing live preview)
 *   - we're still loading site-config (avoid blank-screen flash; show children
 *     until we know maintenance is on)
 */
const ALLOW_DURING_MAINTENANCE = [
  "/checkout/success",
  "/checkout/cancel",
];

export default function MaintenanceGate({ children }) {
  const { pathname } = useLocation();
  const config = useSiteConfig();
  const { user } = useAuth();

  const maintenanceOn = config?.maintenance_mode_enabled === true;
  const isAdmin = !!user;
  const isAllowedPath = ALLOW_DURING_MAINTENANCE.some(
    (p) => pathname === p || pathname.startsWith(`${p}?`) || pathname.startsWith(`${p}/`)
  );

  if (maintenanceOn && !isAdmin && !isAllowedPath) {
    return <UnderConstruction />;
  }
  return children;
}
